/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {useEffect, FC} from 'react';
import {Store} from 'redux';
import {Provider} from 'react-redux';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import {setupNewWebsocketEvent, disconnectRolledSocketsEvent} from 'services/websocket-events';
import hostService from 'services/host-url.service';
import store, {IAppStore} from './store';
import {wsConnect} from 'store/action/websocket';
import {fetchPlatformTimeFromServer} from './utility/date';

import {ReduxDispatchActions} from 'interfaces';

import AppRouter from './routers';

interface IMetaWithValue extends HTMLMetaElement {
  value: string;
}

toast.configure();

export const initiateWebsocketConnection = (store: Store<IAppStore, ReduxDispatchActions>): void => {
  store.dispatch(wsConnect());
  setupNewWebsocketEvent(store);
  disconnectRolledSocketsEvent(store);
};

const App: FC = (): JSX.Element => {
  const addPhenixUriMetaTag = () => {
    const hostUri = hostService.getHostUrl();
    const phenixUriMeta = document.createElement('meta') as IMetaWithValue;

    phenixUriMeta.setAttribute('name', 'phenix-uri');
    phenixUriMeta.setAttribute('value', hostUri);

    document.head.prepend(phenixUriMeta);
  };

  useEffect(() => {
    fetchPlatformTimeFromServer();
    addPhenixUriMetaTag();
  }, []);
  initiateWebsocketConnection(store);

  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
};

export default App;